import { jsx } from 'panel';
export function template() {
  const timerText = this.helpers.getLastRefreshRelativeFormat();
  const fullText = "".concat(this.attr("preface-text"), " ").concat(timerText);
  const isCompact = this.attr("is-compact");
  return jsx("div", {
    sel: '.last-updated-container',
    attrs: {
      elref: "timeDisplayContainer"
    },
    class: {
      'is-compact': isCompact
    }
  }, isCompact ? timerText : fullText);
}